module.exports = __webpack_public_path__ + "img/home-banner-background.64a572a7.jpg";